// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Izuvk","btn":"styles_btn__1gY6o"};